import { ReactNode } from 'react';

type SectionTitleProps = {
  children: ReactNode;
  className?: string;
};

export const SectionTitle = ({ children, className = '' }: SectionTitleProps) => {
  return (
    <h2 className={['tw-font-jost tw-text-[32px] tw-font-bold tw-text-white lg:tw-text-[40px]', className].join(' ')}>
      {children}
    </h2>
  );
};



